import autobind from 'autobind-decorator';
import { Injectable } from '@kaokei/use-vue-service';
import { gatherInfo, preGatherInfo } from '~/api/oj/contest';
import { getNoviceTask } from '~/api/oj/home';
import {postRegisterTraining} from '~/api/oj/training';
import type { GatherInfoVO, NoviceTaskList } from '~/types/auto/oj';
import { showErrorMsg } from '~/utils/utility';
import { INFO_GATHER_TYPE } from '~/utils/constant';

@Injectable()
export class FreshTasksService {
  public gatherInfoVisible = false;
  public formBtnDisabled = true;

  public preGatherInfo: any = {
    loading: true,
    data: {},
  };
  public gatherInfo: any = {
    formData: {},
    loading: false,
  };
  public noviceTasks: NoviceTaskList = {
    missionList: [],
  };
  @autobind
  goCompeletePersonInfo() {
    this.gatherInfoVisible = true;
  }
  init() {
    getNoviceTask().then((res) => {
      if (Array.isArray(res.missionList) && res.missionList.length > 0) {
        this.noviceTasks = res;
      }
    }).catch((err) => {
      console.error('获取新手任务失败', err);
    })
  }

  @autobind
  joinTraining(tid:number) {
    return postRegisterTraining({tid})
  }


  @autobind
  checkPreGatherInfo() {
    this.preGatherInfo.loading = true;
    preGatherInfo({
      gatherType: INFO_GATHER_TYPE.NOVICE_TASK,
    })
      .then((res) => {
        this.preGatherInfo.data = res;
      })
      .catch((err) => {
        showErrorMsg('预检信息失败', err);
      })
      .finally(() => {
        this.preGatherInfo.loading = false;
      });
  }
  private getFieldValue(field: string) {
    return this.preGatherInfo.data[field] || this.gatherInfo.formData[field];
  }

  @autobind
  public handleOnValidate() {
    const fields = ['realName', 'city', 'schoolName', 'realGrade'];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const value = this.getFieldValue(field);
      if (!value) {
        this.formBtnDisabled = true;
        return;
      }
    }
    this.formBtnDisabled = false;
  }

  @autobind
  public completeUserInfo() {
    this.gatherInfo.loading = true;
    return gatherInfo(Object.assign({}, this.gatherInfo.formData, {
      gatherType: INFO_GATHER_TYPE.NOVICE_TASK,
    }))
      .then((res) => {
        this.gatherInfoVisible = false;
        this.init();
      })

      .finally(() => {
        this.gatherInfo.loading = false;
      });
  }
}
